import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/star.svg";
var StarOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  StarOutline_default as default
};
